var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 512 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445 386.7 L360.2 300.8 C374 276.7 381.2 249.9 381.2 222.9 C381.2 135.3 310 64 222.6 64 C135.2 64 64 135.3 64 222.9 C64 310.5 135.2 381.8 222.6 381.8 C250.5 381.8 278.1 374.1 302.7 359.4 L387.1 445 C389 446.9 391.7 448.1 394.4 448.1 C397.1 448.1 399.8 447 401.7 445 L445 401.2 C449 397.1 449 390.7 445 386.7 Z M222.6 125.9 C276 125.9 319.4 169.4 319.4 222.9 C319.4 276.4 276 319.9 222.6 319.9 C169.2 319.9 125.8 276.4 125.8 222.9 C125.8 169.4 169.2 125.9 222.6 125.9 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.7157e0d9376066181c11be9d97a88678.svg";
export { ForwardRef as ReactComponent };